import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
            <ToastContainer
                position="top-right"
                autoClose={5000}
                pauseOnHover
                draggable
                theme="light"
            />
        </BrowserRouter>
    </React.StrictMode>,
);
